<script>
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import debounce from "lodash.debounce";
import Middleware from "@/helpers/middlewares";

// Custom components
import BookingService from "@/helpers/APIService/booking.service";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import { booking_guest_type, booking_bill_to } from "@/helpers/global.variable";
import GuestService from "@/helpers/APIService/guest.service";
import roomService from "@/helpers/APIService/room.service";

export default {
  components: {
    Multiselect,
    DatePicker,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  data() {
    return {
      booking_guest_type,
      booking_bill_to,
      popoverShow: false,
      value: null,
      roomTypes: [],
      roomRatePlans: [],
      tempRoomRatePlans: [],
      tabIndex: 0,
      bookingSources: [],
      filterData: {
        bookingSource: null,
        daterange: [],
        totalNights: "1",
      },
      selected: {
        roomType: null,
        roomRatePlans: null,
        totalRooms: "1",
      },
      filterString: "",
      rooms: [],
      roomsCopy: [],
      initialRooms: [],
      notes: null,
      guest_type: "individual",
      companies: [],
      company: null,
      bill_to: "guest",
      payment_mode: null,
      special_request: null,
      //guest info
      mobile_code: "+1 ",
      guest_detail: {
        mobile: "",
        email: "",
        last_name: "",
        first_name: "",
      },
      total_adult: 1,
      total_child: 0,
      guestList: [],
      adultSelectOption: [
        { text: "1", value: "1", disabled: false },
        { text: "2", value: "2", disabled: false },
        { text: "3", value: "3", disabled: false },
        { text: "4", value: "4", disabled: false },
        { text: "5", value: "5", disabled: false },
        { text: "6", value: "6", disabled: false },
        { text: "7", value: "7", disabled: false },
        { text: "8", value: "8", disabled: false },
        { text: "9", value: "9", disabled: false },
        { text: "10", value: "10", disabled: false },
      ],
      guestSelectOption: [
        { text: "0", value: "0", disabled: false },
        { text: "1", value: "1", disabled: false },
        { text: "2", value: "2", disabled: false },
        { text: "3", value: "3", disabled: false },
        { text: "4", value: "4", disabled: false },
        { text: "5", value: "5", disabled: false },
        { text: "6", value: "6", disabled: false },
        { text: "7", value: "7", disabled: false },
        { text: "8", value: "8", disabled: false },
        { text: "9", value: "9", disabled: false },
        { text: "10", value: "10", disabled: false },
      ],
      selectedRoomRatePlanPriceID: null,
      selectedRoomTypeID: null,
      pricePerNight: null,
      room_allotment: [],
      current_no_of_room: 0,
      disable_next_button: true,
      temp_room_no_arr: [],
      is_btn_loading: false,
      is_data_loading: true,
      total_avl_room: 0,
      pre_check_in_email: false,
      submitted: false,
      isBtnLoading: false,
      openPopup: false,

      // Additional Field related
      additionalFields: [],
      additionalFieldDataToSave: [],
    };
  },
  computed: {
    ...authComputed,
  },
  watch: {
    "filterData.daterange": function (val) {
      var startDate = moment(val[0], "YYYY-MM-DD");
      var endDate = moment(val[1], "YYYY-MM-DD");
      this.filterData.totalNights = endDate.diff(startDate, "days");
      this.searchRoom();
    },
    "selected.totalRooms": function (val) {},
    "selected.roomType": function (val) {
      if (val != null) {
        this.rooms = this.initialRooms.filter((room) => val.id === room.id);
        this.roomsCopy = this.rooms;
      } else {
        this.rooms = this.initialRooms;
        this.roomsCopy = this.initialRooms;
      }
      this.room_allotment = [];
      this.disable_next_button = true;
    },
    "selected.roomRatePlans": function (val) {
      if (val != null) {
        this.rooms = this.roomsCopy.map((room) => {
          let rate_plan = room.rate_plan.filter(
            (ratePlan) => val.id == ratePlan.id
          );
          return { ...room, rate_plan };
        });
      } else {
        this.rooms = this.roomsCopy;
      }
    },
  },
  mounted() {
    this.getBookingSources();
    this.getCompanies();
    this.setNewBookingFromBookingTable();
  },
  methods: {
    setNewBookingFromBookingTable() {
      if (this.currentProps.newBookingData !== undefined) {
        this.filterData.daterange = [];
        this.filterData.daterange.push(
          moment(this.currentProps.newBookingData.start_date).format(
            "YYYY-MM-DD"
          )
        );
        this.filterData.daterange.push(
          moment(this.currentProps.newBookingData.end_date)
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        );
      }
    },
    async getBookingSources() {
      if (this.hotel.is_pms_connection) {
        const date = localStorage.getItem("last_audit");
        this.filterData.daterange.push(moment(date).format("YYYY-MM-DD"));
        this.filterData.daterange.push(
          moment(date).add(1, "d").format("YYYY-MM-DD")
        );
      } else {
        this.filterData.daterange.push(moment().format("YYYY-MM-DD"));
        this.filterData.daterange.push(
          moment().add(1, "d").format("YYYY-MM-DD")
        );
      }
      await UserService.getBookingSourceList(this.hotel.id)
        .then((sources) => {
          sources.map((item) => {
            if (item.name !== "Kiosk") {
              this.bookingSources.push(item);
            }
          });
          this.filterData.bookingSource = sources[0];
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    bookingSourceChange() {
      this.searchRoom();
    },
    async searchRoom() {
      this.isBtnLoading = true;
      this.is_data_loading = true;
      this.filterString = "";
      if (this.filterData.bookingSource != null) {
        this.filterString +=
          "?booking_source=" + this.filterData.bookingSource.id;
      }
      if (
        this.filterData.daterange[0] !== undefined &&
        this.filterData.daterange[1] !== undefined
      ) {
        if (this.filterString == "") {
          this.filterString +=
            "?check_in_date=" +
            moment(this.filterData.daterange[0]).format("YYYY-MM-DD");
          this.filterString +=
            "&check_out_date=" +
            moment(this.filterData.daterange[1]).format("YYYY-MM-DD");
        } else {
          this.filterString +=
            "&check_in_date=" +
            moment(this.filterData.daterange[0]).format("YYYY-MM-DD");
          this.filterString +=
            "&check_out_date=" +
            moment(this.filterData.daterange[1]).format("YYYY-MM-DD");
        }
      }

      await roomService
        .getRoomDetailsForBookingCreate(this.filterString)
        .then((room_types) => {
          this.initialRooms = room_types;
          this.rooms = room_types;
        })
        .catch((error) => {
          errorHandler(error);
        });
      this.roomTypes = [];
      this.total_avl_room = 0;
      this.rooms.map((room) => {
        this.total_avl_room += room.available_room;
        this.roomTypes.push({
          id: room.id,
          name: room.short_name + "-" + room.name,
        });

        let obj = [];
        if (room.rate_plan.length !== 0) {
          room.rate_plan.map((ratePlan) => {
            ratePlan.total_rooms = "demo";
            obj = [
              ...obj,
              {
                id: ratePlan.id,
                name: ratePlan.name,
              },
            ];
            ratePlan.price = parseFloat(0);
            ratePlan.plan_price_date_wise.map((price) => {
              ratePlan.price = (
                parseFloat(ratePlan.price) + parseFloat(price.room_price)
              ).toFixed(2);
            });

            ratePlan.avgPrice = parseFloat(0);
            ratePlan.plan_price_date_wise.map((price) => {
              ratePlan.avgPrice =
                parseFloat(ratePlan.avgPrice) + parseFloat(price.room_price);
            });
            ratePlan.avgPrice = (
              ratePlan.avgPrice / ratePlan.plan_price_date_wise.length
            ).toFixed(2);
          });
        }
        this.roomRatePlans = [];
        this.tempRoomRatePlans = [...this.tempRoomRatePlans, ...obj];
        this.roomRatePlans = Array.from(
          new Set(this.tempRoomRatePlans.map(JSON.stringify))
        ).map(JSON.parse);
      });
      this.rooms = this.rooms.map((room) => {
        if (room.rate_plan.length == 0) {
          room = { ...room, total_rooms: room.total_room, total_room: 0 };
        }
        return room;
      });
      this.current_no_of_room = 0;
      this.room_allotment = [];
      this.is_data_loading = false;
      this.isBtnLoading = false;
    },
    setAdditionalFieldInBooking() {
      this.hotel.booking_additional_field.map((item) => {
        let valueArr = [];
        item.value.map((vItem) => {
          if (vItem.is_show_on_booking) {
            if (this.additionalFields.length == 0) {
              this.additionalFields.push({
                key: item.key,
                value: [...valueArr, vItem],
              });
            } else {
              this.additionalFields.map((aItem) => {
                if (aItem.key == item.key) {
                  aItem.value.push(vItem);
                } else {
                  this.additionalFields.push({
                    key: item.key,
                    value: [...valueArr, vItem],
                  });
                }
              });
            }
          }
        });
      });
      this.additionalFields = [
        ...new Map(
          this.additionalFields.map((item) => [item["key"], item])
        ).values(),
      ];
    },
    updateAdditionalField(answer, data) {
      data = { ...data, value: answer };
      let finalData = [];
      this.additionalFields.map((item) => {
        if (item.key == data.section_text) {
          item.value = item.value.map((vItem) => {
            if (vItem.field_label == data.field_label) {
              vItem = data;
            }
            return vItem;
          });
        }
        finalData.push(item);
      });
      this.additionalFieldDataToSave = [
        ...new Map(finalData.map((item) => [item["key"], item])).values(),
      ];
    },
    async getCompanies() {
      await GuestService.getCompanyList()
        .then((companies) => {
          companies.map((company) => {
            this.companies.push(company);
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    clearFilter() {
      this.rooms = this.initialRooms;
      this.selected.roomType = null;
      this.selected.roomRatePlans = null;
    },
    changeOtherGuestFields(guest) {
      this.guest.mobile = guest.mobile;
      this.guest.first_name = guest.first_name;
      this.guest.last_name = guest.last_name;
      this.guest.email = guest.email;
    },
    getDateWisePrice(rate_plan) {
      let string = "<ul class='w-100'>";
      for (let i = 0; i < rate_plan.plan_price_date_wise.length; i++) {
        string +=
          "<li><span>" +
          moment(rate_plan.plan_price_date_wise[i].day_date).format(
            "MMM DD , "
          ) +
          "$" +
          rate_plan.plan_price_date_wise[i].room_price +
          "</span></li>";
      }
      string += "</ul>";
      return {
        html: true,
        content: () => {
          return string;
        },
      };
    },
    showTextBox(rate_plan, room_type_id) {
      if (rate_plan !== "std_rate") {
        this.selectedRoomRatePlanPriceID = rate_plan.id;
        this.selectedRoomTypeID = room_type_id;
        this.pricePerNight = rate_plan.avgPrice;
      } else {
        this.selectedRoomRatePlanPriceID = "";
        this.selectedRoomTypeID = room_type_id.id;
        this.pricePerNight = room_type_id.std_rate;
      }
    },
    changePricePerNight(room_type_index, room_rate_plan_index) {
      if (room_rate_plan_index !== "std_rate") {
        this.rooms[room_type_index].rate_plan[room_rate_plan_index].avgPrice =
          this.pricePerNight;
        this.rooms[room_type_index].rate_plan[room_rate_plan_index].price =
          this.pricePerNight *
          this.rooms[room_type_index].rate_plan[room_rate_plan_index]
            .plan_price_date_wise.length;
        this.selectedRoomRatePlanPriceID = null;
        this.selectedRoomTypeID = null;
        this.pricePerNight = null;
      } else {
        this.rooms[room_type_index].std_rate = this.pricePerNight;
        this.selectedRoomRatePlanPriceID = null;
        this.selectedRoomTypeID = null;
        this.pricePerNight = null;
      }
    },
    countCurrentRoom() {
      this.current_no_of_room = 0;
      this.room_allotment.map((noOfRoom, index) => {
        this.current_no_of_room = parseInt(
          parseInt(this.current_no_of_room) + parseInt(noOfRoom.selectedRoom)
        );
        BookingService.getRoomNoAvailabilityByRoomType(
          "?check_in_date=" +
            this.filterData.daterange[0] +
            "&check_out_date=" +
            this.filterData.daterange[1] +
            "&room_type=" +
            noOfRoom.room_type_id
        )
          .then((response) => {
            this.room_allotment[index]["avl_room"] = response;
          })
          .catch((error) => {
            errorHandler(error);
          });
        // }
      });
      if (this.selected.totalRooms >= this.current_no_of_room) {
        this.disable_next_button = false;
      } else {
        this.disable_next_button = true;
      }
    },
    clearField() {
      this.guest_detail.email = "";
      this.guest_detail.first_name = "";
      this.guest_detail.last_name = "";
      this.guest_detail.mobile = "";
    },
    removeNumberDecorations(mobile_number) {
      const mobile_number_copy = mobile_number.replace(" ", "");
      let number = mobile_number_copy.replace(/[^a-zA-Z0-9 ]/g, "");
      return number;
    },
    nextTab() {
      this.popoverShow = false;
      if (this.tabIndex == 2) {
        this.is_btn_loading = true;
        this.guest_detail.mobile =
          this.guest_detail.mobile !== ""
            ? this.removeNumberDecorations(this.guest_detail.mobile).charAt(
                0
              ) == "1"
              ? this.removeNumberDecorations(this.guest_detail.mobile)
              : this.removeNumberDecorations("1" + this.guest_detail.mobile)
            : "";
        let obj = {
          booking_source: this.filterData.bookingSource.id,
          check_in_date: moment(this.filterData.daterange[0]).format(
            "YYYY-MM-DD"
          ),
          check_out_date: moment(this.filterData.daterange[1]).format(
            "YYYY-MM-DD"
          ),
          check_in_time: this.hotel.check_in_time,
          check_out_time: this.hotel.check_out_time,
          reservation_charge: this.addInTotalPrice(),
          notes: this.notes,
          guest_detail: {
            ...this.guest_detail,
            special_notes: this.special_request,
          },
          room_type: "",
          allotted_room: "",
          additional_field: this.additionalFieldDataToSave,
          total_room: parseInt(this.selected.totalRooms),
          stay_night: this.filterData.totalNights,
          pre_check_in_email: this.pre_check_in_email,
          total_guest: parseInt(
            parseInt(this.total_adult) + parseInt(this.total_child)
          ),
          total_adults: parseInt(this.total_adult),
          total_children: parseInt(this.total_child),
          total_charge: this.addInTotalPrice(),
        };

        this.room_allotment.map((item) => {
          obj.room_type = item.room_type_id;
          obj.allotted_room = item.room;
        });
        if (obj.allotted_room == "") {
          delete obj.allotted_room;
        }
        BookingService.createBooking(obj)
          .then(async (booking) => {
            this.$emit("submitted", booking);
            this.is_btn_loading = false;
          })
          .catch((error) => {
            this.is_btn_loading = false;
            errorHandler(error);
          });
      } else if (this.tabIndex == 0) {
        this.tabIndex++;
        this.disable_next_button = false;
      } else if (this.tabIndex == 1) {
        if (this.guest != null) {
          this.submitted = true;
          this.$v.$touch();
          if (this.$v.$invalid) {
            this.isBtnLoading = false;
            return;
          } else {
            this.submitted = false;
            let selectedGuest;
            this.guestList.map((guest) => {
              if (this.guest_detail.email === guest.email) {
                selectedGuest = guest;
              }
            });
            if (selectedGuest !== undefined || null) {
              if (!selectedGuest.is_premium_guest) {
                this.room_allotment = this.room_allotment.map((item) => {
                  item.avl_room = item.avl_room.filter(
                    (room) => !room.is_premium_room
                  );
                  return item;
                });
              }
            }
            this.tabIndex++;
          }
        } else {
          if (
            this.guest_detail.email == null ||
            this.guest_detail.email == ""
          ) {
            Middleware.notification("Please enter email !!", "warning", 3000);
          } else {
            this.tabIndex++;
          }
        }
      } else {
        this.tabIndex++;
      }
    },
    reserveRoom(roomType, room_plan_rate) {
      this.room_allotment = [];
      let tempObj = {
        room_type_id: roomType.id,
        room_type: roomType.name,
        rate_plan_id: room_plan_rate == "std_rate" ? "" : room_plan_rate.id,
        rate_plan: room_plan_rate == "std_rate" ? "" : room_plan_rate.name,
        room: "",
        price_per_night:
          room_plan_rate == "std_rate"
            ? roomType.std_rate
            : room_plan_rate.avgPrice,
        total_price:
          room_plan_rate == "std_rate"
            ? roomType.std_rate
            : room_plan_rate.price,
        selectedRoom: 1,
      };
      this.room_allotment.push(tempObj);
      this.countCurrentRoom();
      this.nextTab();
    },
    previousTab() {
      this.is_btn_loading = false;
      this.popoverShow = false;
      if (this.tabIndex == 0) {
        this.$emit("cancelSubmit");
      } else {
        this.tabIndex--;
      }
    },
    addInTotalPricePerNight() {
      let total_price_per_night = 0;
      this.room_allotment.map((room) => {
        total_price_per_night =
          parseFloat(total_price_per_night) + parseFloat(room.price_per_night);
      });
      return parseFloat(total_price_per_night).toFixed(2);
    },
    addInTotalPrice() {
      let total_price = 0;
      this.room_allotment.map((room) => {
        total_price = parseFloat(total_price) + parseFloat(room.total_price);
      });
      return parseFloat(
        parseFloat(total_price).toFixed(2) * this.filterData.totalNights
      ).toFixed(2);
    },
    roomNoChange(room_type) {
      const tempA = this.room_allotment.map((item) => {
        if (item.room !== event.target.value) {
          let avl_room = item.avl_room.filter(
            (avlRoom) => avlRoom.id !== event.target.value
          );
          item = { ...item, avl_room };
          return item;
        }
      });
      if (this.temp_room_no_arr.length > 0) {
        var str = this.temp_room_no_arr.find(
          (p) => p.room_type == room_type && p.room_no == event.target.value
        );
        if (!str) {
          this.temp_room_no_arr.push({
            room_type: room_type,
            room_no: event.target.value,
          });
        } else {
          event.target.value = 0;
          Middleware.notification(
            "Room number already selected !!",
            "warning",
            3000
          );
        }
      } else {
        this.temp_room_no_arr.push({
          room_type: room_type,
          room_no: event.target.value,
        });
      }
    },
    handleHit(trackBy, data = null) {
      if (data == null) {
        this.guest = null;
      } else {
        this.guest = data.id;
        this.guest_detail.mobile = data.mobile;
        this.guest_detail.email = data.email;
        this.guest_detail.last_name = data.last_name;
        this.guest_detail.first_name = data.first_name;
      }
    },
    openPopupBtn() {
      this.openPopup = !this.openPopup;
    },
    onClose() {
      this.popoverShow = false;
      this.openPopupBtn();
    },
    onOk() {
      this.nextTab();
      this.openPopupBtn();
    },
    debounceMethod: debounce(async function ($evt) {
      let findVal = String($evt.target.value);
      if (findVal.length >= 3 && findVal.length <= 6) {
        const response = await BookingService.findGuest(findVal);
        this.guestList = [];
        response.results.map((item) => {
          this.guestList.push(item);
        });
      }
    }, 200),
  },
  validations() {
    return {
      guest_detail: {
        first_name: {
          required,
        },
        last_name: {
          required,
        },
      },
    };
  },
};
</script>

<template>
  <div class="">
    <div class="offcanvas-header p-0">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel">
        New Reservation
      </h5>
    </div>
    <hr />
    <b-tabs
      v-model="tabIndex"
      justified
      nav-class="nav-tabs-custom"
      content-class="p-3 text-muted"
    >
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Book a room</span>
        </template>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">
                <label
                  >Date to stay <span class="text-danger">*</span>
                  <span class="badge badge-soft-primary ps-3 pe-3 fs-6"
                    >{{ filterData.totalNights }} Nights</span
                  ></label
                >
                <br />
                <date-picker
                  lang="en"
                  placeholder="Select date to stay"
                  v-model="filterData.daterange"
                  range
                  type="date"
                  value-type="format"
                  :disabled-date="notBeforeToday"
                  :clearable="false"
                ></date-picker>
              </div>
              <div class="col-md-2">
                <label>Booking source <span class="text-danger">*</span></label>
                <multiselect
                  v-model="filterData.bookingSource"
                  :options="bookingSources"
                  :show-labels="false"
                  track-by="id"
                  label="name"
                  class=""
                  placeholder="Select booking source"
                  @close="bookingSourceChange()"
                ></multiselect>
              </div>

              <div class="col-md-3">
                <label for="select_room_type">Room Type</label>
                <div class="">
                  <multiselect
                    v-model="selected.roomType"
                    :options="this.roomTypes"
                    :show-labels="false"
                    track-by="id"
                    label="name"
                    placeholder="Select Room Type"
                  ></multiselect>
                </div>
              </div>
              <div class="col-md-3">
                <label for="select_room_type">Rate Plan</label>
                <div class="">
                  <multiselect
                    v-model="selected.roomRatePlans"
                    :options="roomRatePlans"
                    :show-labels="false"
                    track-by="id"
                    label="name"
                    placeholder="Select Room Rate"
                  ></multiselect>
                </div>
              </div>
              <div class="col-md-1 mt-1 px-0">
                <b-button
                  variant="primary"
                  class="mt-4"
                  type="submit"
                  @click="searchRoom()"
                  :class="{ disabled: isBtnLoading }"
                  ><i
                    v-if="isBtnLoading"
                    class="bx bx-loader bx-spin font-size-16 align-middle me-1"
                  ></i>
                  Search
                </b-button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title my-3">
                      {{ total_avl_room }} room(s) available
                    </h4>
                    <div class="table-responsive">
                      <table
                        class="table table-hover table-bordered table-sm mb-0"
                      >
                        <thead class="table-light">
                          <tr>
                            <th>Room Type (Avl.)</th>
                            <th>Rate plan</th>
                            <th width="20%">Price / Night</th>
                            <th>Total ({{ filterData.totalNights }})</th>
                            <th width="10%">Reserve Room</th>
                          </tr>
                        </thead>
                        <tbody
                          v-for="(roomType, room_type_index) in rooms"
                          :key="room_type_index"
                        >
                          <tr v-if="!is_data_loading">
                            <th scope="row" colspan="5">
                              {{ roomType.name }} ({{
                                roomType.available_room
                              }})
                            </th>
                          </tr>
                          <template v-if="roomType.rate_plan.length !== 0">
                            <tr
                              v-for="(
                                room_plan_rate, room_rate_plan_index
                              ) in roomType.rate_plan"
                              :key="room_rate_plan_index"
                            >
                              <td v-if="!is_data_loading"></td>
                              <td v-if="!is_data_loading">
                                {{ room_plan_rate.name }}
                              </td>
                              <td v-if="!is_data_loading">
                                <b-form-input
                                  v-if="
                                    selectedRoomRatePlanPriceID ==
                                      room_plan_rate.id &&
                                    selectedRoomTypeID == roomType.id
                                  "
                                  id="name-input"
                                  v-model="pricePerNight"
                                  type="number"
                                  autocomplete="off"
                                  size="sm"
                                  @blur="
                                    changePricePerNight(
                                      room_type_index,
                                      room_rate_plan_index
                                    )
                                  "
                                ></b-form-input>
                                <span
                                  v-else
                                  v-b-popover.hover="
                                    getDateWisePrice(room_plan_rate)
                                  "
                                  @click="
                                    showTextBox(room_plan_rate, roomType.id)
                                  "
                                  >${{ room_plan_rate.avgPrice }}</span
                                >
                              </td>
                              <td v-if="!is_data_loading">
                                ${{ room_plan_rate.price }}
                              </td>
                              <td v-if="!is_data_loading">
                                <button
                                  class="btn btn-sm btn-primary"
                                  @click="reserveRoom(roomType, room_plan_rate)"
                                  :class="{
                                    disabled: roomType.available_room < 1,
                                  }"
                                >
                                  Reserve
                                </button>
                              </td>
                            </tr>
                          </template>
                          <template v-else>
                            <tr>
                              <td v-if="!is_data_loading"></td>
                              <td v-if="!is_data_loading">
                                {{ "STD RATE" }}
                              </td>
                              <td v-if="!is_data_loading">
                                <b-form-input
                                  v-if="
                                    selectedRoomRatePlanPriceID == '' &&
                                    selectedRoomTypeID == roomType.id
                                  "
                                  id="name-input"
                                  v-model="pricePerNight"
                                  type="number"
                                  autocomplete="off"
                                  size="sm"
                                  @blur="
                                    changePricePerNight(
                                      room_type_index,
                                      'std_rate'
                                    )
                                  "
                                ></b-form-input>
                                <span
                                  v-else
                                  @click="showTextBox('std_rate', roomType)"
                                  >${{ roomType.std_rate }}</span
                                >
                              </td>
                              <td v-if="!is_data_loading">
                                ${{ roomType.std_rate }}
                              </td>
                              <td v-if="!is_data_loading">
                                <button
                                  class="btn btn-sm btn-primary"
                                  @click="reserveRoom(roomType, 'std_rate')"
                                  :class="{
                                    disabled: roomType.available_room < 1,
                                  }"
                                >
                                  Reserve
                                </button>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                        <tbody v-if="is_data_loading">
                          <tr>
                            <td class="placeholder-glow" colspan="5">
                              <span
                                class="placeholder w-100 placeholder-lg"
                              ></span>
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td class="placeholder-glow" colspan="5">
                              <span
                                class="placeholder w-100 placeholder-lg"
                              ></span>
                            </td>
                          </tr>
                          <tr>
                            <td class="placeholder-glow" colspan="5">
                              <span
                                class="placeholder w-100 placeholder-lg"
                              ></span>
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td class="placeholder-glow" colspan="5">
                              <span
                                class="placeholder w-100 placeholder-lg"
                              ></span>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-if="!is_data_loading && rooms.length == 0">
                          <tr>
                            <td colspan="8" class="text-center">
                              <img
                                src="@/assets/images/empty.svg"
                                class="img-fluid"
                                alt=""
                              />
                              <p>
                                <span class="text-secondary"
                                  >No Data Found</span
                                >
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="far fa-user"></i>
          </span>
          <span class="d-none d-sm-inline-block">Add Info</span>
        </template>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-8">
                <div class="card">
                  <div class="card-body">
                    <h5 class="offcanvas-title" id="offcanvasExampleLabel">
                      PRIMARY GUEST
                    </h5>
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <b-form-group class="mb-3" label-for="guest-type-input">
                          <span slot="label"> Guest Type </span>
                          <b-form-select
                            class="form-select"
                            id="guest-type-input"
                            v-model="guest_type"
                            :options="booking_guest_type"
                          >
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          class="mb-3"
                          label-for="company-input"
                          v-if="
                            guest_type != '' &&
                            guest_type != null &&
                            guest_type != 'individual'
                          "
                        >
                          <span slot="label"> Company </span>
                          <multiselect
                            v-model="company"
                            :options="companies"
                            :show-labels="false"
                            track-by="id"
                            label="name"
                            class=""
                            placeholder="Select Company"
                          ></multiselect>
                        </b-form-group>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label for="name"
                          >Last Name <span class="text-danger">*</span></label
                        >
                        <input
                          id="name"
                          name="last_name"
                          type="text"
                          class="form-control"
                          autocomplete="off"
                          v-model="guest_detail.last_name"
                          :class="{
                            'is-invalid':
                              submitted && $v.guest_detail.last_name.$error,
                          }"
                        />
                        <div
                          v-if="submitted && $v.guest_detail.last_name.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.guest_detail.last_name.required"
                            >Last Name is required.</span
                          >
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label for="text"
                          >First Name <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="email"
                          name="email"
                          v-model="guest_detail.first_name"
                          autocomplete="off"
                          :class="{
                            'is-invalid':
                              submitted && $v.guest_detail.first_name.$error,
                          }"
                        />
                        <div
                          v-if="submitted && $v.guest_detail.first_name.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.guest_detail.first_name.required"
                            >First Name is required.</span
                          >
                        </div>
                      </div>

                      <div class="col-md-6 mb-3">
                        <label for="email">E-mail </label>
                        <input
                          type="email"
                          class="form-control"
                          id="email"
                          name="email"
                          v-model="guest_detail.email"
                          autocomplete="off"
                        />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label for="name">Mobile </label>
                        <vue-tel-input
                          v-model="guest_detail.mobile"
                          autoFormat
                          :dropdownOptions="{
                            showDialCodeInList: true,
                            showDialCodeInSelection: true,
                            showFlags: true,
                            width: '390px',
                            showSearchBox: true,
                          }"
                        ></vue-tel-input>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          class="mb-3"
                          label-for="select-adult-input"
                        >
                          <span slot="label">
                            Adult <span class="text-danger">*</span>
                          </span>
                          <b-form-select
                            class="form-select"
                            id="select-adult-input"
                            v-model="total_adult"
                            :options="adultSelectOption"
                          >
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group class="mb-3" label-for="guest-type-input">
                          <span slot="label"> Children </span>
                          <b-form-select
                            class="form-select"
                            id="guest-type-input"
                            v-model="total_child"
                            :options="guestSelectOption"
                          >
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div class="col-md-12">
                        <div class="mb-3">
                          <label>Special Request</label>
                          <textarea
                            class="form-control"
                            name="textarea"
                            rows="3"
                            v-model="special_request"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card">
                  <div class="card-body">
                    <h5 class="offcanvas-title" id="offcanvasExampleLabel">
                      BOOKING OPTIONS
                    </h5>
                    <hr />
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="fw-bolder" for="bill-to-input"
                          >Bill To</label
                        >
                        <b-form-select
                          class="form-select"
                          id="bill-to-input"
                          v-model="bill_to"
                          :options="booking_bill_to"
                        >
                        </b-form-select>
                      </div>
                      <div class="mb-3">
                        <label class="fw-bolder">Note</label>
                        <textarea
                          class="form-control"
                          name="textarea"
                          rows="3"
                          v-model="notes"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-md-12 d-flex">
                      <b-form-checkbox
                        type="checkbox"
                        v-model="pre_check_in_email"
                        name="pre_check_in_email"
                        id="pre_check_in_email"
                        class="checkbox-round"
                      />
                      <label
                        class="form-check-label ms-1"
                        for="pre_check_in_email"
                        >Send Pre-Check In Email ?</label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-md-6"
                v-for="(item, mIndex) in additionalFields"
                :key="mIndex"
              >
                <b-card>
                  <h5 class="offcanvas-title" id="offcanvasExampleLabel">
                    {{ item.key }}
                  </h5>
                  <div class="row">
                    <div
                      class="col-md-6 mb-2"
                      v-for="(addField, index) in item.value"
                      :key="index"
                    >
                      <p class="label-text mb-2">
                        {{ addField.field_text }}
                        <span v-if="addField.is_required" class="text-danger"
                          >*</span
                        >
                      </p>
                      <template v-if="addField.answer_type == 'text'">
                        <input
                          type="text"
                          class="form-control"
                          :required="addField.is_required"
                          :name="addField.field_label"
                          autocomplete="off"
                          @focusout="
                            updateAdditionalField($event.target.value, addField)
                          "
                        />
                      </template>
                    </div>
                  </div>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="far fa-envelope"></i>
          </span>
          <span class="d-none d-sm-inline-block">Confirm</span>
        </template>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-hover mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Room Type</th>
                        <th>Room #</th>
                        <th class="text-center">Date</th>
                        <th>Rate plan</th>
                        <th>Price / Night</th>
                        <th>Price *</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(confirm_room, index) in room_allotment"
                        :key="index"
                      >
                        <th scope="row">{{ confirm_room.room_type }}</th>
                        <td>
                          <select
                            name="no_pms"
                            id="no_pms"
                            v-model="confirm_room.room"
                            class="form-select"
                            @change="roomNoChange(confirm_room.room_type_id)"
                          >
                            <option value="">Select Room</option>
                            <option
                              :value="avl_room.id"
                              v-for="(
                                avl_room, room_avl_index
                              ) in confirm_room.avl_room"
                              :key="room_avl_index"
                            >
                              {{ avl_room.room_number }}
                            </option>
                          </select>
                        </td>
                        <td>
                          <div
                            class="d-flex align-items-center justify-content-center"
                          >
                            {{
                              global_format_date_and_time_custom(
                                filterData.daterange[0],
                                "DD MMM"
                              )
                            }}
                            <div class="night-border text-center mx-2">
                              <p
                                class="mb-0 badge-soft-info d-flex align-items-center justify-content-center"
                              >
                                {{ filterData.totalNights }}
                              </p>
                              <i class="fas fa-long-arrow-alt-right fs-3"></i>
                            </div>
                            {{
                              global_format_date_and_time_custom(
                                filterData.daterange[1],
                                "DD MMM"
                              )
                            }}
                          </div>
                        </td>
                        <td>{{ confirm_room.rate_plan }}</td>
                        <td>
                          ${{
                            parseFloat(confirm_room.price_per_night).toFixed(2)
                          }}
                        </td>
                        <td>
                          ${{ parseFloat(confirm_room.total_price).toFixed(2) }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>Total</th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <th>${{ addInTotalPricePerNight() }}</th>
                        <th>${{ addInTotalPrice() }}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center justify-content-center">
          <b-button
            variant="outline-primary"
            type="button"
            @click="previousTab()"
            v-if="tabIndex != 0"
          >
            Previous
          </b-button>
          <div class="position-relative">
            <b-button
              id="popover-button-event"
              variant="primary"
              class="ms-2"
              type="button"
              :disabled="disable_next_button"
              :class="{ disabled: is_btn_loading }"
              v-if="tabIndex !== 0"
              @click="openPopupBtn()"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="is_btn_loading"
              ></i>
              {{ tabIndex != 2 ? "Next" : "Confirm" }}
            </b-button>
            <div class="custom-popover" v-show="openPopup">
              <div
                class="d-flex align-items-center justify-content-center bg-primary rounded-top p-2"
              >
                <i class="fas fa-info-circle text-light me-2"></i>
                <h5 class="mb-0 text-light">Are you sure ?</h5>
              </div>
              <div class="bg-primary bg-soft rounded-bottom text-center p-2">
                <button class="btn btn-sm btn-primary m-1" @click="onClose">
                  No
                </button>
                <button class="btn btn-sm btn-primary m-1" @click="onOk">
                  yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.custom-popover {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  width: 160px;
}
</style>
